import { render, staticRenderFns } from "./InvButtonCard.vue?vue&type=template&id=09257f25&scoped=true&"
import script from "./InvButtonCard.vue?vue&type=script&lang=js&"
export * from "./InvButtonCard.vue?vue&type=script&lang=js&"
import style0 from "./InvButtonCard.vue?vue&type=style&index=0&id=09257f25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09257f25",
  null
  
)

export default component.exports